import { render, staticRenderFns } from "./TutorialModal.vue?vue&type=template&id=475614cf&scoped=true"
import script from "./TutorialModal.vue?vue&type=script&lang=js"
export * from "./TutorialModal.vue?vue&type=script&lang=js"
import style0 from "./TutorialModal.vue?vue&type=style&index=0&id=475614cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475614cf",
  null
  
)

export default component.exports